import { useEffect, useState } from 'react';

import { getWindowSafe } from '@change-corgi/core/window';

import { useScrollToStory } from '../useScrollToStory';

export function useFirstDesktopToMobileSwitch() {
	const window = getWindowSafe();
	const [startedOnDesktop, setStartedOnDesktop] = useState(false);
	const [hasSwitchedToMobileOnce, setHasSwitchedToMobileOnce] = useState(false);
	const scrollToStory = useScrollToStory();

	useEffect(() => {
		if (!window) return () => {};
		// eslint-disable-next-line react-hooks/set-state-in-effect
		setStartedOnDesktop(window.innerWidth >= 1024);

		const handleResize = () => {
			const resizedWindow = getWindowSafe();
			if (!resizedWindow) return;
			const isMobile = resizedWindow.innerWidth < 1024;

			if (startedOnDesktop && isMobile && !hasSwitchedToMobileOnce) {
				scrollToStory(3, { behavior: 'auto' });
				setHasSwitchedToMobileOnce(true);
			}
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [setHasSwitchedToMobileOnce, startedOnDesktop, window, hasSwitchedToMobileOnce, scrollToStory]);
}
